<template>
  <vx-card no-shadow>
    <div class="vx-row mb-5">
      <div class="vx-col w-full">
        <!--Class with one line and two columns-->
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Nome</label>
            <div class="mt-2">
              <vs-input
                class="w-full"
                type="text"
                name="mensagem de comentário"
                v-model="name"
              />
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="mt-2">
              <label for="favcolor" class="text-sm font-bold"
                >Selecione a cor:</label
              >
              <br />
              <input
                type="color"
                id="favcolor"
                name="favcolor"
                value=" #ffffff"
                v-model="color"
              /><br />
              <!-- {{ color }} -->
              <!-- <label class="text-sm font-bold">Cor</label> -->
            </div>
          </div>

          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="mt-2">
              <p class="text-sm font-bold">Mínimo</p>
              <vs-input
                class="w-full"
                type="range"
                min="0"
                max="100"
                v-model="lower_percentage"
                @change="onValueChange"
              />

              <p>{{ lower_percentage }}%</p>
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <div class="mt-2">
              <p class="text-sm font-bold">Máximo</p>
              <vs-input
                class="w-full"
                type="range"
                min="0"
                max="100"
                v-model="high_percentage"
                @change="onValueChange"
              />

              <p>{{ high_percentage }}%</p>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveData">Salvar</vs-button>
        </div>

        <vs-table :data="proficiencias">
          <!-- <template slot="header">
         
                <vs-button  @click="popupAdd = true" icon-pack="feather" icon="icon-plus" color="primary" type="border"
                class="mb-2">Nova proficiencia</vs-button>

            </template> -->

          <template slot="thead">
            <vs-th sort-key="name">Nome</vs-th>
            <vs-th sort-key="description">Grau mínimo</vs-th>
            <vs-th sort-key="percent">Grau alto</vs-th>
            <vs-th>Cor</vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>
              <vs-td :data="data[indextr].lower_percentage">
                {{ data[indextr].lower_percentage }} %
              </vs-td>
              <vs-td :data="data[indextr].high_percentage">
                {{ data[indextr].high_percentage }} %
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <input
                  type="color"
                  id="favcolor"
                  name="favcolor"
                  :value="data[indextr].color"
                  disabled
                />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </vx-card>
</template>

<script>
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
export default {
  mixins: [PermissionsMixin],
  data() {
    return {
      name: "",
      lower_percentage: 50,
      high_percentage: 50,
      color: "",
      proficiencias: [],
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    onValueChange() {
      this.value = this.input.value;
    },

    async saveData() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        name: this.name,
        lower_percentage: this.lower_percentage,
        high_percentage: this.high_percentage,
        color: this.color,
      };

      this.$validator.validateAll();
      await http
        .post("performances/proficiency_levels", data, config)
        .then((success) => {
          success;
          (this.popupAdd = false), this.getData();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Salvo com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
          if (error.response.status == 422) {
            this.err = error.response.data;
            console.log(this.err);
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },

    getData() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get(`performances/proficiency_levels`, config)
        .then((result) => {
          this.proficiencias = result.data;
        })
        .catch((error) => {
          error;
          this.$vs.loading();
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },
  },
};
</script>
